module.exports = __webpack_public_path__ + "static/media/SH 31.5cc171e9.mp3";